import uuid from "react-uuid"   

class DGElement {
    /*** Members ***/
    
    // Define members here... All members must be private!
    
    /*** Private Methods ***/
    
    /*** Protected Methods ***/
    
    protected _init = () => {
        // Initialize or set all members based on constructor argument values 
        // Perform additional setup here...
    }
    
    // Define private methods (including initializers for members) here...
    
    /*** Public Methods ***/
    
    public constructor() {
        this._init()
    }
    
    /**
     * Generate a random string of characters to be used as a unique id
     *
     * @returns {string | number[]} - The result of the call to the uuid function
     */
    public createID = (): string | number[] => {
        return uuid()
    }
}

export default DGElement
